var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"at-floatchat",class:_vm.floatChatClass,attrs:{"id":`floatchat_${_vm.chatId}`}},[_c('div',{staticClass:"at-floatchat_content"},[_c('guppywidget-chat-box-header',{attrs:{"chatInfo":_vm.chatInfo}}),_c('messages-container',{attrs:{"chatId":_vm.chatId}}),_c('guppywidget-chat-box-footer',{attrs:{"chatInfo":_vm.chatInfo}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }